const getField = (
  obj: Record<string, unknown>,
  path: string,
  separator = '/',
): unknown => {
  if (!obj || typeof obj !== 'object') {
    throw new Error('Invalid object provided');
  }

  const keys = path.split(separator);

  let current = obj;

  for (const key of keys) {
    if (!current || typeof current !== 'object') {
      return undefined;
    }
    current = current[key] as Record<string, unknown>;
  }

  return current;
};

export default getField;
